module.exports = __webpack_public_path__ + "static/img/btn-blocky-EN-NON.1202d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/btn-blocky-EN-NON.png
// module id = /kSw
// module chunks = 1